export default "__VITE_ASSET__35fe2b27__"